import { render } from "./PedidosImportadosColombia.vue?vue&type=template&id=b9338442"
import script from "./PedidosImportadosColombia.vue?vue&type=script&lang=js"
export * from "./PedidosImportadosColombia.vue?vue&type=script&lang=js"

import "./PedidosImportadosColombia.vue?vue&type=style&index=0&id=b9338442&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__